import { Input as AntdInput, type InputProps } from "antd";
import { TextAreaProps } from "antd/es/input";

const Input = (props: InputProps) => {
  return <AntdInput {...props} />;
};

const TextArea = (props: TextAreaProps) => {
  return <AntdInput.TextArea {...props} />;
};

Input.TextArea = TextArea;

export { Input };
